export default __webpack_public_path__ + "a92172ed8a1bf12b83378d2f61eaedea.gif";